/**
 * Format a work schedule template label for dropdowns.
 * Appends schedule type only when it adds information not already in the name.
 */
export function formatWorkScheduleTemplateLabel(template) {
  const name = template?.name || '';
  const display = template?.schedule_type_display || '';
  if (!display) return name;

  const nameLower = name.toLowerCase();
  const displayLower = display.toLowerCase();
  if (nameLower.includes(displayLower)) return name;

  const typeToken = displayLower.split(/\s+/)[0];
  if (typeToken.length >= 3 && nameLower.includes(typeToken)) return name;

  return `${name} (${display})`;
}
